module.exports = __webpack_public_path__ + "img/truck.27dd0c63.png";